<template xmlns="http://www.w3.org/1999/html">
  <div class="page-wrapper">
    <div class="flex-wrapper">
      <div class="menu-container">
        <strong>Select Date</strong>
        <input type="date" class="form-control" v-model="selectedDateFrom"/>
        <input type="date" class="form-control" v-model="selectedDateTo"/>
        <button class="btn btn-primary form-control" v-on:click="getDayOrderList">Get</button>

      </div>
      <div class="list-container">
        <table class="table">
          <tr>
            <th>#</th>
            <th style="min-width: 150px;">Date</th>
            <th style="min-width: 150px;">Credit Note</th>
            <th class="text-left">Shop</th>
            <th>NET</th>
            <th>VAT</th>
            <th>GROSS</th>
            <th>Status</th>
          </tr>
          <tbody v-for="order in orders" >
          <tr v-on:click="onItemClicked(order.id)"  :class="'order-item-state-'+ order.state + ' hover-item'" >
            <td>{{order.id}}</td>
            <td>{{order.creditDate}}</td>
            <td>
              <strong>
                <span v-if="order.invoice != null" v-on:click.stop="openInvoiceView(order.id)"><span v-if="order.invoice.title != null && order.invoice.title.length > 0">{{order.invoice.title}}</span><i v-else class="fas fa-file-alt" style="color:green;"></i> </span>
              </strong>
            </td>
            <td class="text-left">{{getMerchantName(order.merchantId)}}</td>
            <td>{{(order.totalPrice/100).toFixed(2)}}</td>
            <td>{{(order.tax/100).toFixed(2)}}</td>
            <td>{{(order.finalDue/100).toFixed(2)}}</td>
            <td>
              {{orderStateString(order.state)}}
            </td>
          </tr>
          </tbody>
          <tbody v-if="user.manageCredit === true">
          <tr>
            <td>New</td>
            <td colspan="2">
              <select class="form-control" v-model="newOrderMerchantId">
                <option value="0">Select Shop</option>
                <option v-for="m in merchants" :value="m.id">{{m.title}}</option>
              </select>
            </td>
            <td>
              <input type="date" class="form-control" v-model="newOrderDeliveryDate"/>
            </td>
            <td colspan="2">
              <span class="form-control" v-on:click="createNewOrder"><i class="fas fa-plus-circle"></i> Create</span>
            </td>
            <td colspan="2" class="text-left" style="color: red;">
              Use this only to create credit for non product related. To make a credit for products, Go to order page and use "Credit" button
            </td>
          </tr>
          </tbody>
        </table>
      </div>


      <transition name="slideup">
        <div class="item-container" v-if="currentOrder !== false" v-on:click="closeCurrentOrder(true)">
          <div class="card"  style="border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
            <div class="card-header" style="position: sticky; top:0; z-index: 2; background-color: #A9E1FF;">
              <span style="float:left; height:38px; line-height: 38px; font-weight: bold; font-size: 20px;">#{{currentOrder.id}} {{getMerchantName(currentOrder.merchantId)}}</span>

              <button class="btn btn-primary" style="float:right; display:none;" v-on:click="refreshItem(currentOrder.id)">Refresh</button>
              <button class="btn btn-dark" style="float:right; margin-right:10px;" v-on:click="closeCurrentOrder(true)">Close</button>
              <button class="btn btn-success" style="float:right; margin-right:10px;" v-on:click="getHistory('Credit Order History', 'Credit Order Number ' + currentOrder.id, 'orderId='+currentOrder.id)"><i class="fas fa-history"></i> History</button>
            </div>
            <div class="card-body text-left">
              <table class="text-left">
                <tr>
                  <td style="padding-left:10px;">Shop:</td>
                  <td>{{getMerchantName(currentOrder.merchantId)}}</td>
                </tr>

                <tr>
                  <td style="padding-left:10px;">Date:</td>
                  <td><input type="date" v-model="currentOrder.creditDate" @change="onOrderChanged" :disabled="isAdmin()===false || currentOrder.state === 100"/></td>
                </tr>
                <tr>
                  <td style="padding-left:10px;">Status</td>
                  <td>
                    {{orderStateString(currentOrder.state)}}
                  </td>
                </tr>


              </table>
              <div>

              </div>
              <div class="section-header">Details</div>
              <table class="table" style="margin-top:40px; font-size: small;">
                <tr>
                  <th class="text-left">Item</th>
                  <th>Stock Type</th>
                  <th class="text-center">Qty</th>

                  <th>Price</th>
                  <th>NET</th>
                  <th>VAT</th>
                  <th>GROSS</th>
                  <th></th>

                  <!--                <th>Status</th>-->
                </tr>
                <tbody v-for="(item, ii) in currentOrder.list" v-bind:class="{['order-item-state-' + item.state]: true, 'order-item-low-stock': item.state >= 0 && item.state < 20 && item.product != null && item.amount > item.product.currentStock}">
                <tr class="order-item-row" v-bind:class="{'item-cancelled':item.state < 0}">
                  <td class="text-left">
                    <div v-if="item.productId > 0 || item.state < 0 || item.state >= 20 || user.manageCredit === false">
                      <strong>{{item.title}}</strong>
                    </div>
                    <div v-else>
                      <input v-model="item.title" style="width: 100%; height: 40px; line-height: 40px;" @change="onOrderChanged"/>
                    </div>

                  </td>
                  <td>

                    <select v-model="item.stockType" v-on:change="onOrderChanged" :disabled="item.productId > 0 || item.state < 0 || item.state >= 20 || user.manageCredit === false">
<!--                            :disabled="user.type !== 'ROLE_ADMIN' || item.state < 0 || item.state > 100">-->
                      <option v-if="item.productId > 0" value="return">Stock Return</option>
                      <option value="disposal">Disposal</option>
                      <option value="partial_refund">Partial Refund</option>
                    </select>
                  </td>
                  <td class="text-center">

                    <div v-if="item.productId > 0 || item.state < 0 || item.state >= 20 || user.manageCredit === false">
                      {{item.amount}}
                    </div>
                    <div v-else>
                      <input v-if="item.state >= 0 && item.state < 20" type="number" v-model="item.amount" style="width:70px; text-align: center;" v-on:change="onOrderChanged"/>
                    </div>
<!--                    <input v-if="item.state >= 0 && item.state < 20" type="number" v-model="item.amount" style="width:70px; text-align: center;" v-on:change="onOrderChanged" :disabled="user.type !== 'ROLE_ADMIN'"/>-->

                    <!--                  {{item.amount}}-->
<!--                    <span v-else>{{item.amount}}</span>-->
                  </td>
                  <td class="text-center">
<!--                    {{item.priceFloat.toFixed(2)}}-->

                    <input v-if="item.state >=0 && item.state < 100 || user.manageCredit === false" type="number" v-model="item.price" style="width:70px; text-align: center;" v-on:change="onOrderChanged" :disabled="user.type !== 'ROLE_ADMIN' || item.state < 0"/>
                    <div v-else>{{item.priceFloat.toFixed(2)}}</div>
                  </td>
                  <td>{{(item.totalPrice/100).toFixed(2)}}</td>
                  <td>
                    <div v-if="item.productId > 0 || item.state < 0 || item.state >= 20 || user.manageCredit === false">
                      {{(item.taxRate/100).toFixed(0)}}% ({{(item.tax/100).toFixed(2)}})
                    </div>
                    <div v-else>
                      <select v-model="item.taxRate" @change="onOrderChanged">
                        <option value="0">Zero Rate</option>
                        <option value="2000">Standard Rate (20%)</option>
                      </select>
                    </div>
                  </td>
                  <td>{{(item.finalDue/100).toFixed(2)}}</td>
                  <td>
                    <!--                      <span v-if="item.state == 0" v-on:click="confirmOrderItem(item.id)"><i class="far fa-check-circle" style="color:grey;"></i></span>-->
                    <!--                      <span v-else-if="item.state >= 20"><i class="fas fa-check-circle" style="color:blue;"></i></span>-->
                    <span v-if="item.state >= 0 && item.state < 100 && user.manageCredit === true" v-on:click="deleteItem(item)" style="margin-left:10px;"><i class="fas fa-trash" style="color:red;"></i></span>


                    <!--                  <span v-if="item.confirmedAmount > 0">{{item.confirmedAmount}}</span><span v-else >Confirm</span></td>-->
                  </td>

                  <!--                <td>-->
                  <!--                  {{orderStateString(item.state)}}-->
                  <!--                  <select v-model="item.state" class="form-control" style="display: none;">-->
                  <!--                    <option value="0">To Be Confirmed</option>-->
                  <!--                    <option value="20">Confirmed</option>-->
                  <!--                    <option value="-100">Reject</option>-->
                  <!--                  </select>-->
                  <!--                </td>-->
                </tr>

                <template v-if="item.useVariablePrice === true">
                  <tr class="order-item-row">
                    <td/><td/>
                    <td class="text-right">
                      <input type="number" style="width:80px; text-align: center" v-model="item.variablePriceAmount" @change="onOrderChanged" :disable="item.state < 0 || item.state >= 30"  :disabled="user.type !== 'ROLE_ADMIN' || currentOrder.state >= 100"/>kg
                    </td>
                    <td>
                      £ <input type="number" style="width:70px;" v-model="item.variablePricePerUnit" @change="onOrderChanged" :disable="item.state < 0 || item.state >= 30"  :disabled="user.type !== 'ROLE_ADMIN' || currentOrder.state >= 100"/>/kg
                    </td>
                    <td colspan="4"/>
                  </tr>
                </template>
                <template v-if="item.notes != undefined && item.notes != null && item.notes.length > 0">
                  <tr class="memo-row" >
                    <td colspan="8" class="text-left">
                      <div class="memo-container">
                        <div class="memo-item" v-for="note in item.notes">
                          <div class="memo-header">
                            <strong>{{note.userName}}'s note: </strong> @{{timeString(note.createdTimestamp)}}
                            <span v-if="user.manageCredit === true && note.userId == user.id" v-on:click="askRemoveNote(note)"><i class="fas fa-trash"></i></span>
                            <br>
                            <span class="note-receiver" v-if="note.toAll == true"> <i class="fas fa-users" style="color:green;"></i></span><span class="note-receiver" v-if="note.toShop == true"> <i class="fas fa-store-alt" style="color:red;"></i></span><span class="note-receiver" v-if="note.toDriver == true"> <i class="fas fa-truck" style="color:blue;"></i></span>
                          </div>
                          <div class="memo-content">

                            {{note.description}}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                </template>
                <tr class="memo-row" v-if="user.manageCredit === true && currentOrder.state >= 0 && currentOrder.state < 100">
                  <td colspan="8" style="padding-bottom: 5px;">
                    <input class="form-control" v-model="item.note" v-on:change="onItemNoteAdded(ii)" placeholder="Type memo and press enter key"/>
                  </td>
                </tr>
                </tbody>
                <tbody>
                <tr v-if="user.manageCredit === true && currentOrder.state >= 0 && currentOrder.state < 100" style="display: none;">
                  <td colspan="3">
                    <!--                    <autocomplete-->
                    <!--                      :search="search"-->
                    <!--                      :get-result-value="getResultValue"-->
                    <!--                      @submit="handleSubmit"-->
                    <!--                      ref="autocomplete">-->

                    <!--                    </autocomplete>-->
                    Add Order
                    <div style="width: 100%; display: flex;">
                      <input type="text" v-model="searchWord" id="credit-product-candidate-search-input" v-on:keyup="search" style="width: calc(100% - 50px)" placeholder="Search Product"/>
                      <span style="height: 30px; line-height: 30px; padding-left:10px;" v-on:click="initialiseSearch"><i class="fas fa-times"></i></span>
                    </div>
                    <ul class="autocomplete-results" v-if="candidates.length > 0">
                      <li class="autocomplete-result" v-for="(candidate, ci) in candidates" :tabindex="ci" :id="'credit-product-candidate-'+ci" :key="'credit-product-candidate-'+ci" v-on:keyup="moveFocusOnCandidate($event, candidate)" v-on:click.stop="selectCandidate(candidate)">
                        {{candidate.title}}
                      </li>
                    </ul>
                  </td>

                </tr>
                </tbody>
                <tr>
                  <th class="text-left">Total</th>
                  <th></th>

                  <th></th>
                  <th>{{(currentOrder.totalPrice/100).toFixed(2)}}</th>

                  <th>{{(currentOrder.tax/100).toFixed(2)}}</th>
                  <th><strong>DUE: {{(currentOrder.finalDue/100).toFixed(2)}}</strong></th>
                  <th></th>
                </tr>
              </table>

              <template v-if="currentOrder.notes != undefined && currentOrder.notes != null && currentOrder.notes.length > 0">
                Order Note:
                <div class="memo-container">
                  <div class="memo-item" v-for="note in currentOrder.notes">
                    <div class="memo-header">
                      <strong>{{note.userName}}'s note: </strong> @{{timeString(note.createdTimestamp)}}
                      <span v-if="note.userId === user.id" v-on:click="askRemoveNote(note)"><i class="fas fa-trash"></i></span>
                      <br>
                      <span class="note-receiver" v-if="note.toAll === true"> <i class="fas fa-users" style="color:green;"></i></span><span class="note-receiver" v-if="note.toShop === true"> <i class="fas fa-store-alt" style="color:red;"></i></span><span class="note-receiver" v-if="note.toDriver === true"> <i class="fas fa-truck" style="color:blue;"></i></span>
                    </div>
                    <div class="memo-content">
                      {{note.description}}
                    </div>
                  </div>
                </div>
              </template>
              <input v-if="user.manageCredit === true && currentOrder.state < 100" type="text" class="form-control" v-model="currentOrder.note" v-on:change="newNoteAdded" :disabled="user.manageCredit === false"/>

              <br/>
              <br/>
              <button class="btn btn-primary" @click="addNonProductItem">Add New Non Product Item</button> (Use this to create non product related credit. For product credit, Use "Credit" button on order page)
            </div>
            <div class="card-footer text-right">
              <button class="btn btn-danger" style="float:left;" v-if="currentOrder.state >= 0 && currentOrder.state < 100 && user.manageCredit === true" v-on:click="deleteOrder(currentOrder)">DELETE</button>
              <button class="btn btn-primary" v-if="currentOrder.state >= 0 && currentOrder.state < 100 && user.manageCredit === true" v-on:click="completeOrder(currentOrder.id)">Complete Order</button>

              <button class="btn btn-success" v-if="currentOrder.state >= 0 && currentOrder.state <= 30&& currentOrder.state < 30 && user.manageCredit === true" v-on:click="invoiceOrder(currentOrder.id)">Credit Note 발행하기</button>
              <button class="btn btn-success" v-if="currentOrder.imageUrls != null && currentOrder.imageUrls.length > 0" v-on:click="openInvoiceView(currentOrder.id)">Credit Note 보기</button>
              <button class="btn btn-primary" v-if="currentOrder.imageUrls != null && currentOrder.imageUrls.length > 0" v-on:click="sendInvoice(currentOrder.id)">Email Credit Note</button>

<!--              <button class="btn btn-primary" v-if="currentOrder.state <= 30 && isManager() == true" v-on:click="confirmOrder(currentOrder.id)">Confirm Order</button>-->


              <button class="btn btn-dark" v-on:click="closeCurrentOrder(true)">Close</button>

              <span v-if="currentOrder.state === 100 && user.manageCredit === true" >
                <br><br>
                <button class="btn btn-danger" v-on:click="cancelCreditOrder(currentOrder.id)">CANCEL CREDIT</button>
              </span>
<!--              <button class="btn btn-primary" v-on:click="saveOrder" v-if="isManager() == true">Save</button>-->

<!--              <div class="state-btn-container" style="padding-top:20px;">-->
<!--                <div class="state-button" v-for="state in stateList" v-if="state.btnTitle != undefined && state.icon != undefined" v-bind:class="{'state-active': currentOrder.state >= state.state}" v-on:click="changeOrderState(state.state)">-->
<!--                  <div class="state-icon" v-bind:style="{backgroundImage: 'url(' + state.icon + ')'}">-->

<!--                  </div>-->
<!--                  <div class="state-btn-title">-->
<!--                    {{state.btnTitle}}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="newNote != false" v-on:click="cancelNewNote">
          <div style="position: absolute; width: 500px; height: 500px; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
            <div class="container">
              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <h4>Add Memo</h4>
                </div>
              </div>
              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <textarea class="form-control" v-model="newNote.description" rows="3">

                  </textarea>

                </div>
              </div>

              <div class="row" style="margin-top:20px;">
                <div class="col-6">
                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toAll == true}" v-on:click="newNote.toAll = !newNote.toAll">To All</div>
                </div>
                <div class="col-6">
                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toShop == true}" v-on:click="newNote.toShop = !newNote.toShop">To Shop</div>
                </div>
<!--                <div class="col-4">-->
<!--                  <div class="form-control plane-btn" v-bind:class="{'selected': newNote.toDriver == true}" v-on:click="newNote.toDriver = !newNote.toDriver">To Driver</div>-->
<!--                </div>-->
              </div>
              <div class="row" style="margin-top:40px;">
                <div class="col-6">
                  <button class="form-control btn btn-dark" v-on:click="cancelNewNote">Cancel</button>
                </div>
                <div class="col-6">
                  <button class="form-control btn btn-primary" v-on:click="onNoteConfirmed">Add Note</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slideup">
        <div class="item-container" v-if="invoiceView != false" v-on:click="closeInvoiceView()">
          <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
            <div style="width:800px; height:100%; padding-top:10px;">
              <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + invoiceView.invoice.description" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
            </div>
            <div style="width:calc(100% - 800px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">
              <h5>{{getMerchantName(invoiceView.merchantId)}}</h5>
              <h6>Order Number: {{invoiceView.id}}</h6>
              <h6>Credit Note Number: {{invoiceView.invoice.title}}</h6>
              <br>
              <br>
              <h6>NET: £{{(invoiceView.totalPrice/100.0).toFixed(2)}}</h6>
              <h6>TAX: £{{(invoiceView.tax/100.0).toFixed(2)}}</h6>
              <h6>GROSS: £{{(invoiceView.finalDue/100.0).toFixed(2)}}</h6>

              <br>
              <br>
              <h6>Credit Date: {{invoiceView.creditDate}}</h6>
              <br>
              <br>
              <button class="form-control btn btn-dark" v-on:click="regenerateInvoice(invoiceView.id)">REGENERATE CREDIT NOTE</button>
              <br>
              <br>
              <button class="form-control btn btn-primary" v-on:click="sendInvoice(invoiceView.id)">SEND CREDIT NOTE</button>

              <table style="width: 100%; margin-top:20px;">
                <tr>
                  <td style="vertical-align: top; vertical-align: top;">
                    Email to:
                  </td>
                  <td style="text-align: left; vertical-align: top;">
                    <div v-html="getMerchantEmailList(invoiceView.merchantId)"/>
                  </td>

                </tr>

              </table>


            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {
    addMemo,
    cancelOrder, completeOrder,
    deleteMemo,
    getOrder,
    getOrderStateList, invoiceOrder,
    queryOrders,
    refreshOrder, sendInvoiceOrder,
    updateOrder
  } from "../api/order";
  import {millisToDate, millisToReadable, setLastPage, showDialog} from "../api/utils";
    import {searchProducts} from "../api/product";
    import {getUserByToken} from "../api/user";
    import {getMerchants} from "../api/merchant";
  import {
    cancelCreditOrder,
    completeCreditOrder, deleteCreditOrder,
    deleteCreditOrders,
    getCreditOrder,
    invoiceCreditOrder,
    queryCreditOrders, sendInvoiceCreditOrder,
    updateCreditOrder
  } from "../api/creditOrder";
  import EventBus from "../api/event-bus";

    export default {
        name: "CreditOrders",
      data() {
        return {
          orders:[],
          merchants:[],
          selectedMerchantId:0,
          selectedState:0,
          stateList:getOrderStateList(),
          currentOrder:false,
          merchantType:'all',
          productOrderItems: false,
          dateFrom:'',
          dateTo:'',
          selectedDate:'',
          selectedDateFrom:'',
          selectedDateTo:'',
          user: false,
          searchWord:'',
          candidates:[],
          newOrderMerchantId:0,
          newOrderDeliveryDate:'',
          newNote: false,
          changeItem: false,
          invoiceView: false,
          newOrderCreditDate:'',

        }
      },
      created() {
        setLastPage(this.$route.path);
        this.$data.dateFrom = millisToDate(new Date().getTime(), '-');
        this.$data.dateTo = millisToDate(new Date().getTime(), '-');
        if(localStorage.getItem("credit-order-date-from") !== null) {
          this.$data.selectedDateFrom = localStorage.getItem("credit-order-date-from");
        } else {
          this.$data.selectedDateFrom = millisToDate(new Date().getTime(), '-');
        }
        if(localStorage.getItem("credit-order-date-to") !== null) {
          this.$data.selectedDateTo = localStorage.getItem("credit-order-date-to");
        } else {
          this.$data.selectedDateTo = millisToDate(new Date().getTime(), '-');
        }
        this.$data.selectedDate = millisToDate(new Date().getTime(), '-');


        this.$data.newOrderCreditDate = millisToDate(new Date().getTime(), '-');
      },
      mounted() {

        this.getMyInfo();

      },
      methods: {
        dateString: millisToDate,
        initialiseSearch: function () {
          this.$data.searchWord = '';
          this.$data.candidates = [];
        },
        search: function(e){
          if(e.key == 'ArrowDown') {
            console.log('ArrowDown');
            let firstCandidate = document.getElementById('credit-product-candidate-0');
            if(firstCandidate != undefined && firstCandidate != null) {
              firstCandidate.focus();
            } else {
              console.log("cannot find ele");
            }
            return;
          }
          let self = this;
          console.log("Search " + this.$data.searchWord);
          if(this.$data.searchWord == null || this.$data.searchWord.length < 3) {
            this.$data.candidates = [];
            return;
          }


          searchProducts(this.$data.searchWord, this.$data.currentOrder.merchantId, 0)
            .then(function(data) {
              console.log("search result ");
              console.log(data);
              if(data.success == true) {
                self.$data.candidates =  data.item;
              } else {
                self.$data.candidates = [];
              }
            })
            .catch(function(err) {
              self.$data.candidates = [];
            })
          // return new Promise((resolve) => {
          //   if(input.length < 3) {
          //     resolve([]);
          //   }
          //   // self.searchProduct(encodeURI(input), resolve);
          //
          // })

        },
        moveFocusOnCandidate: function(e, c) {
          const activeEle = e.target;
          // const activeEleIndex = Array.prototype.indexOf.call(activeEle.parentElement, activeEle);
          console.log(e);
          console.log(c);
          // console.log("index " + activeEleIndex);
          console.log(e.key);
          if(e.key == "ArrowDown" && activeEle.nextElementSibling != null) {
            console.log("move down");
            activeEle.nextElementSibling.focus();
          }

          if(e.key == "ArrowUp")
            if(activeEle.previousElementSibling != null) {
              console.log("move up");
              activeEle.previousElementSibling.focus();
            } else {
              document.getElementById("credit-product-candidate-search-input").focus();
            }

          if(e.key == 'Enter') {

            if(activeEle.nextElementSibling != null) {
              activeEle.nextElementSibling.focus();
            } else if(activeEle.previousElementSibling != null) {
              activeEle.previousElementSibling.focus();
            }
            this.selectCandidate(c);
          }
        },
        addNonProductItem: function() {
          let newOrder = {
            id:0,
            parentId:this.$data.currentOrder.id,
            title:'',
            priceFloat:0.00,
            price:0,
            amount:1,
            taxRate:0,
            finalDue:0,
            tax: 0,
            totalPrice:0,
            merchantId:this.$data.currentOrder.merchantId,
            productId:0,
            stockType:'disposal',

          }
          this.$data.currentOrder.list.push(newOrder);


          this.onOrderChanged();
        },
        selectCandidate: function(candidate) {
          // this.$data.candidates = [];

          let newOrder = {
            id:0,
            parentId:this.$data.currentOrder.id,
            title:candidate.title,
            price:candidate.price/100.0,
            amount:1,
            taxRate:candidate.taxRate,
            finalDue:0,
            tax: candidate.price * candidate.taxRate / 10000,
            totalPrice:candidate.price,
            merchantId:this.$data.currentOrder.merchantId,
            productId:candidate.id,
            product:JSON.parse(JSON.stringify(candidate)),
            useVariablePrice: candidate.useVariablePrice,
            variablePriceUnit: candidate.variablePriceUnit,
            stockType:'return',

          }
          this.$data.currentOrder.list.push(newOrder);

          for(let i = 0 ; i < this.$data.candidates.length ; i++) {
            if(this.$data.candidates[i].id == candidate.id) {
              this.$data.candidates.splice(i, 1);
              break;
            }
          }
          this.onOrderChanged();

        },
        isAdmin: function() {
          if(this.$data.user != false && this.$data.user.type === 'ROLE_ADMIN') {
            return true;
          }
          return false;
        },
        isManager: function() {
          if(this.$data.user != false && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_MANAGER')) {
            return true;
          }
          return false;
        },
        getMyInfo: function() {
          let self = this;
          getUserByToken()
            .then(function(data) {
              self.$data.user = data;
              console.log("user acquired");
              console.log(self.$data.user);
              // if(self.$data.me.type === 'ROLE_ADMIN') {
              self.getMerchantList();

              // }
            })
            .catch(function(err) {

            })
        },
        timeString:millisToReadable,
        getMerchantList: function() {
          let self = this;
          getMerchants()
            .then(function(data) {
              if(data.success == true) {
                self.$data.merchants = data.item;
                self.getDayOrderList();
              } else {

              }
            })
        },
        orderStateString: function(state) {
          for(let i = 0 ; i < this.$data.stateList.length ; i++) {
            if(this.$data.stateList[i].state == state) {
              return this.$data.stateList[i].title;
            }
          }
          return 'State:' + state;
        },
        getDayOrderList: function() {
          let self = this;
          this.$data.currentOrder = false;
          this.$data.orders = [];
          localStorage.setItem("credit-order-date-from", this.$data.selectedDateFrom);
          localStorage.setItem("credit-order-date-to", this.$data.selectedDateTo);
          let query = "dateFrom=" + this.$data.selectedDateFrom + '&dateTo=' + this.$data.selectedDateTo;
          //this.$data.newOrderDeliveryDate = this.$data.selectedDate;
          console.log("get query " + query);
          queryCreditOrders(query)
            .then(function(data) {
              if(data.success == true) {
                self.$data.orders = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        getMerchantName: function(id) {
          if(this.$data.merchants.length == 0) {
            return 'Not Found';
          }

          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              return this.$data.merchants[i].title;
            }
          }
          return 'Unknown(' + id + ')';
        },
        getMerchantEmailList: function(id) {
          if(this.$data.merchants.length == 0) {
            return 'Not Found';
          }


          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              let text = "";
              if(this.$data.merchants[i].emails.length > 0) {
                text += '<strong>' + this.$data.merchants[i].emails.join('<br>') + '</strong>';
              }
              if(this.$data.merchants[i].ccEmails.length > 0) {
                text += '<br>';
                text += this.$data.merchants[i].ccEmails.join('<br>');
              }
              return text;
            }
          }
          return 'Unknown(' + id + ')';
        },
        onItemClicked: function(id) {
          this.$data.currentOrder = false;
          this.openOrderItem(id);
        },
        dummy: function() {
          if(this.$data.candidates.length > 0) {
            this.initialiseSearch();
          }
        },
        refreshItem: function(id) {
          let self = this;
          this.initialiseSearch();
          refreshOrder(id)
            .then(function(data) {
              if(data.success == true) {

                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
                for(let i = 0 ; i < data.item.list.length ; i++) {
                  data.item.list[i].price = (data.item.list[i].price/100.0).toFixed(2);
                }
                self.$data.currentOrder = data.item;

              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response !== undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        closeCurrentOrder: function(close = false) {
          this.initialiseSearch();
          if(close == true) {
            this.$data.currentOrder = false;
          }
        },
        getHistory: function(title, message, query) {
          EventBus.$emit("getHistory", title, message, query);
        },
        openOrderItem: function(id, removeIfStateIsDifferent = false) {
          let self = this;
          // this.initialiseSearch();
          getCreditOrder(id)
            .then(function(data) {
              if(data.success == true) {

                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    let totalWeight = 0;
                    for(let i = 0 ; i < data.item.list.length ; i++) {
                      if(data.item.list[i].useVariablePrice == true) {
                        data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                        data.item.list[i].variablePriceAmount = data.item.list[i].variablePriceAmount / 100.0;
                      }
                      if(data.item.list[i].state >= 0 && data.item.list[i].product != null) {
                        data.item.list[i].weight = data.item.list[i].product.weight;
                        data.item.list[i].totalWeight = data.item.list[i].product.weight * data.item.list[i].amount;
                        totalWeight += data.item.list[i].totalWeight;
                      }
                      // data.item.list[i].discountAmount = data.item.list[i].discountAmount / 100.0;
                    }
                    data.item.totalWeight = totalWeight;
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
                for(let i = 0 ; i < data.item.list.length ; i++) {
                  if(data.item.list[i].useVariablePrice == true) {
                    data.item.list[i].totalPrice = data.item.list[i].variablePricePerUnit * 100 * data.item.list[i].variablePriceAmount * 100 / 100;
                    data.item.list[i].price = (data.item.list[i].price / 100.0).toFixed(2);
                  } else {
                    data.item.list[i].price = (data.item.list[i].price / 100.0).toFixed(2);
                  }
                }
                self.$data.currentOrder = data.item;

              } else {

              }
            })
            .catch(function(err) {

            })
        },
        deleteItem: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            // title: '',
            text: 'Delete ' + item.title + '?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Delete',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.deleteItemConfirmed(item.id);
                }
              },

            ]

          });
        },
        deleteItemConfirmed: function(id) {
          let self = this;
          deleteCreditOrder(id)
            .then(function(data) {
              if(data.success == true) {

                for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                  if(self.$data.currentOrder.list[i].id == data.item.id) {
                    self.$data.currentOrder.list.splice(i, 1);
                    break;
                  }
                }
                self.onOrderChanged();


              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log("Confirm order item error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        deleteOrder: function(order) {
          let self = this;
          this.$modal.show('dialog', {
            // title: '',
            text: 'Delete this credit order?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Delete',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.deleteOrderConfirmed(order.id);
                }
              },

            ]

          });
        },
        deleteOrderConfirmed: function(id) {
          let self = this;
          deleteCreditOrder(id)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {

                    self.$data.orders.splice(i, 1);
                    break;
                  }
                }
                self.closeCurrentOrder(true);


              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log("Confirm order item error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        askRemoveNote: function(note) {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: 'Delete this memo? "' + note.description + '"',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes Delete',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.removeNoteConfirmed(note);
                }
              },

            ]

          });
        },
        removeNoteConfirmed: function(note) {
          let self = this;
          deleteMemo(note.id)
            .then(function(data) {
              if(data.success) {
                if(self.$data.currentOrder != false) {
                  if(self.$data.currentOrder.notes.length > 0) {
                    for(let i = 0 ; i < self.$data.currentOrder.notes.length ; i++) {
                      if(self.$data.currentOrder.notes[i].id == data.item.id) {
                        self.$data.currentOrder.notes.splice(i, 1);
                        return;
                      }
                    }


                  }

                  if(self.$data.currentOrder.list.length > 0) {
                    for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                      if(self.$data.currentOrder.list[i].notes.length > 0) {
                        for(let j = 0 ; j < self.$data.currentOrder.list[i].notes.length ; j++) {
                          if(self.$data.currentOrder.list[i].notes[j].id == data.item.id) {
                            self.$data.currentOrder.list[i].notes.splice(j, 1);
                            return;
                          }
                        }
                      }
                    }
                  }

                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        onItemNoteAdded: function(index) {
          if(this.$data.currentOrder.list[index].note !== undefined && this.$data.currentOrder.list[index].note !== null && this.$data.currentOrder.list[index].note.length > 0) {
            this.$data.newNote = {
              id:0,
              orderId:this.$data.currentOrder.list[index].id,
              description:this.$data.currentOrder.list[index].note,
              toAll:false,
              toShop:false,
              toDriver:false,
            };

            this.$data.currentOrder.list[index].note = '';
          }
        },
        cancelNewNote: function() {
          this.$data.newNote = false;
        },
        onNoteConfirmed: function() {
          let newNote = JSON.parse(JSON.stringify(this.$data.newNote));
          let self = this;
          this.$data.newNote = false;
          addMemo(newNote)
            .then(function(data){
              if(data.success == true) {
                if(self.$data.currentOrder != false) {
                  if(self.$data.currentOrder.id == data.item.orderId) {
                    self.$data.currentOrder.notes.push(data.item);
                    return;
                  }

                  for(let i = 0 ; i < self.$data.currentOrder.list.length ; i++) {
                    if(self.$data.currentOrder.list[i].id == data.item.orderId) {
                      self.$data.currentOrder.list[i].notes.push(data.item);
                      return;
                    }
                  }
                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err){

            })
        },
        newNoteAdded: function() {
          console.log("newNoteAdded")
          if(this.$data.currentOrder.note !== undefined && this.$data.currentOrder.note.length > 0) {
            this.$data.newNote = {
              id:0,
              orderId:this.$data.currentOrder.id,
              description:this.$data.currentOrder.note,
              toAll:false,
              toShop:false,
              toDriver:false,
            };
            this.$data.currentOrder.note = '';
          }
        },

        onOrderChanged: function() {
          this.$data.currentOrder.totalPrice = 0;
          this.$data.currentOrder.tax = 0;
          this.$data.currentOrder.finalDue = 0;
          for(let index = 0 ; index < this.$data.currentOrder.list.length ; index++) {
            if(this.$data.currentOrder.list[index].state < 0) {
              continue;
            }
            console.log("onOrderChanged " + index);
            console.log(this.$data.currentOrder.list[index]);
            if(this.$data.currentOrder.list[index].useVariablePrice === true) {
              if(this.$data.currentOrder.list[index].variablePricePerUnit > 0) {
                this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].variablePricePerUnit * 100 * this.$data.currentOrder.list[index].variablePriceAmount * 100 / 100;
              } else {
                this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].price * this.$data.currentOrder.list[index].variablePriceAmount * 100 / 100;
              }
            } else {
              this.$data.currentOrder.list[index].totalPrice = this.$data.currentOrder.list[index].price * 100 * this.$data.currentOrder.list[index].amount;
            }
            this.$data.currentOrder.list[index].tax = this.$data.currentOrder.list[index].totalPrice * this.$data.currentOrder.list[index].taxRate / 10000
            this.$data.currentOrder.list[index].finalDue = this.$data.currentOrder.list[index].totalPrice + this.$data.currentOrder.list[index].tax;

            this.$data.currentOrder.totalPrice += this.$data.currentOrder.list[index].totalPrice;
            this.$data.currentOrder.tax += this.$data.currentOrder.list[index].tax;
            this.$data.currentOrder.finalDue += this.$data.currentOrder.list[index].finalDue;
          }

          let self = this;
          let item = JSON.parse(JSON.stringify(this.$data.currentOrder));
          for(let i = 0 ; i < item.list.length ; i++) {
            if(item.list[i].useVariablePrice == true) {
              item.list[i].variablePricePerUnit = item.list[i].variablePricePerUnit *100;
              item.list[i].variablePriceAmount = item.list[i].variablePriceAmount *100;
            }
            item.list[i].price = parseInt(parseFloat(item.list[i].price).toFixed(2).replace(".", ""));
            console.log("before update");

          }

          updateCreditOrder(item)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    let totalWeight = 0;
                    for(let i = 0 ; i < data.item.list.length ; i++) {
                      if(data.item.list[i].useVariablePrice == true) {
                        data.item.list[i].variablePricePerUnit = data.item.list[i].variablePricePerUnit / 100.0;
                        data.item.list[i].variablePriceAmount = data.item.list[i].variablePriceAmount / 100.0;
                      }
                      if(data.item.list[i].state >= 0 && data.item.list[i].product != null) {
                        data.item.list[i].weight = data.item.list[i].product.weight;
                        data.item.list[i].totalWeight = data.item.list[i].product.weight * data.item.list[i].amount;
                        totalWeight += data.item.list[i].totalWeight;
                      }
                      // data.item.list[i].discountAmount = data.item.list[i].discountAmount / 100.0;
                    }
                    data.item.totalWeight = totalWeight;
                    self.$data.orders.splice(i, 1, data.item);
                    break;
                  }
                }
                self.openOrderItem(data.item.id);
              } else {
                showDialog(data.message, "OOPS");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response !== undefined) {
                console.log(err.response);
              }
            })
        },


        completeOrder: function(orderId) {
          //Verify
          if(this.$data.currentOrder.state < 0) {
            showDialog("Order is not completable state as it is cancelled", "Sorry");
            return;
          }

          if(this.$data.currentOrder.state > 100) {
            showDialog("This order is already completed", "Sorry");
            return;
          }


          let self = this;
          completeCreditOrder(this.$data.currentOrder.id)
            .then(function(data) {
              if(data.success == true) {

              } else {
                showDialog(data.message, "Sorry Failed to update");
              }
              self.openOrderItem(self.$data.currentOrder.id, true);
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += " (" + err.response + ")";
              }
              showDialog(msg, "Error happened");
            })


        },
        cancelCreditOrder: function(orderId) {
          if(this.$data.currentOrder.state < 0) {
            showDialog("Already Cancelled");
            return;
          }
          if(this.$data.currentOrder.state < 100) {
            showDialog("Cannot cancel credit order that is not completed yet");
            return;
          }
          let self = this;
          console.log("cancel order " + this.$data.currentOrder.id);
          cancelCreditOrder(this.$data.currentOrder.id)
            .then(function(data) {
              if(data.success == true) {

              } else {
                showDialog(data.message, "Sorry Failed to cancel");
              }
              self.openOrderItem(self.$data.currentOrder.id, true);
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += " (" + err.response + ")";
              }
              showDialog(msg, "Error happened");
            })
        },
        invoiceOrder: function(orderId) {
          let self = this;
          console.log("credit note to issue");
          console.log(this.$data.currentOrder);
          invoiceCreditOrder(orderId)
            .then(function(data) {
              if(data.success == true) {
                self.openOrderItem(orderId, true);
              } else {
                showDialog(data.message, "Failed");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        invoice: function(order) {


          let url = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + order.imageUrls[order.imageUrls.length -1];
          window.open(url, '_blank');
          // const FileDownload = require('js-file-download');
          // let self = this;
          // getInvoice(orderId)
          // .then(function(response) {
          //   FileDownload(response.data, "Kokoro-Invoice-" + orderId + ".pdf");
          // })
          // .catch(function(err) {
          //
          // })
        },
        sendInvoice: function(orderId) {
          sendInvoiceCreditOrder(orderId)
            .then(function(data) {
              if(data.success) {
                showDialog("Invoice Successfully Sent")
              } else {
                showDialog(data.message, "Failed");
              }
            })
            .catch(function(err){
              let msg = err;
              console.log(err);
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
                console.log(err.response);
              }
              showDialog(msg, "ERROR");
            })
        },
        regenerateInvoice: function(orderId) {
          let self = this;
          self.$data.invoiceView = false;
          invoiceCreditOrder(orderId)
            .then(function(data) {
              if(data.success == true) {
                self.$data.invoiceView = data.item;

                for(let i = 0 ; i < self.$data.orders.length ; i++) {
                  if(self.$data.orders[i].id == data.item.id) {
                    self.$data.orders.splice(i, 1, data.item);
                  }
                }
              } else {
                showDialog(data.message, "Failed");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        createNewOrder: function() {

          if(this.$data.newOrderMerchantId <= 0) {
            showDialog("Please select Shop");
            return;
          }

          if(this.$data.newOrderCreditDate === '' || this.$data.newOrderCreditDate === '0000-00-00') {
            showDialog("Please select delivery date");
            return;
          }
          let newOrder = {
            id:0,
            merchantId:this.$data.newOrderMerchantId,
            creditDate:this.$data.newOrderCreditDate,

          }
          let self = this;
          updateCreditOrder(newOrder)
            .then(function(data) {
              if(data.success == true) {
                self.$data.orders.push(data.item);
                self.openOrderItem(data.item.id);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        openInvoiceView: function(id) {

          this.$data.invoiceView = false;
          let self = this;
          getCreditOrder(id)
            .then(function(data) {
              if(data.success == true) {


                if(data.item.invoice == null) {
                  showDialog("Invoice is not generated yet");
                  return;
                }
                self.$data.invoiceView = data.item;

              } else {

                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ")";
              }
              console.log(err);
              showDialog(msg, "ERROR");
            })
        },
        closeInvoiceView: function() {
          this.$data.invoiceView = false;
        },
      }
    }
</script>

<style scoped>

select {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
input {
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/CreditOrders.vue